module.exports = __webpack_public_path__ + "static/media/mission-commando.7812b052.jpg";